import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-softer-stools',
  imports: [UpsellCardComponent],
  templateUrl: './softer-stools.component.html',
})
export class SofterStoolsComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.StoolSoftener;
}
